export const listVehicleTypes = {
    FETCH_REQUEST: 'LISTVEHICLE_FETCH_REQUEST',
    FETCH_SUCCESS: 'LISTVEHICLE_FETCH_SUCCESS',
    FETCH_FAILURE: 'LISTVEHICLE_FETCH_FAILURE',
};


